var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * LikeFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLikeFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.27536 20.6461C8.75867 20.8788 9.28742 20.9997 9.82299 21H17.5122C18.3696 21 19.1989 20.691 19.8503 20.1288C20.5017 19.5665 20.9325 18.7881 21.0648 17.9338L21.9652 12.1277C22.0296 11.7138 22.0044 11.2907 21.8911 10.8876C21.7779 10.4845 21.5794 10.1108 21.3093 9.79245C21.0393 9.47405 20.704 9.21844 20.3266 9.04319C19.9492 8.86794 19.5386 8.77721 19.1231 8.77724H14.4026V5.36003C14.4033 4.83798 14.232 4.33047 13.9158 3.91715C13.5995 3.50382 13.1562 3.20807 12.6552 3.07631C12.1543 2.94455 11.6242 2.98422 11.148 3.18911C10.6719 3.39401 10.2766 3.75252 10.0244 4.20839L7.03698 9.58948C6.85672 9.91433 6.76213 10.2804 6.76226 10.6526V18.5459C6.76219 18.9568 6.87753 19.3593 7.09491 19.7069C7.31229 20.0544 7.62282 20.3328 7.99058 20.5098L8.27824 20.6475L8.27536 20.6461ZM3.434 9.85491C3.24575 9.85472 3.05931 9.89195 2.88534 9.96446C2.71137 10.037 2.55327 10.1434 2.4201 10.2775C2.28692 10.4117 2.18127 10.571 2.10918 10.7464C2.0371 10.9217 2 11.1097 2 11.2995V18.7141C2 19.0976 2.15108 19.4655 2.42001 19.7367C2.68894 20.0078 3.05368 20.1602 3.434 20.1602H4.1474C4.33813 20.1602 4.52106 20.0838 4.65592 19.9478C4.79079 19.8118 4.86656 19.6273 4.86656 19.435V10.5787C4.86656 10.3863 4.79079 10.2019 4.65592 10.0659C4.52106 9.92987 4.33813 9.85346 4.1474 9.85346L3.434 9.85491Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLikeFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLikeFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLikeFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-like-filled') === undefined) {
    customElements.define('cat-icon-like-filled', BlocksIconLikeFilled);
}
